import { Inject, Injectable, NestMiddleware } from '@nestjs/common';
import { Response } from 'express';
import { TokenService } from '../services/token.service';
import { RequestCustom } from '@ip6m/server/shared';
import { ConfigurationService } from '@ip6m/server/feature-configuration';
import { FRONTEND_BASE_URL } from '@ip6m/server/config';

@Injectable()
export class ContextMiddleware implements NestMiddleware {
  constructor(
    @Inject(FRONTEND_BASE_URL) private frontendBaseUrl: string,
    private tokenService: TokenService, 
    private configService: ConfigurationService) {}

  async use(req: RequestCustom, res: Response, next: () => void) {

    const serverConfig = await this.configService.getConfiguration;

    req.context = {};

    if(this.frontendBaseUrl != "http://localhost:4200" && serverConfig.userAuthEnabled) {
      const accessToken = req.headers.authorization;
      if (accessToken && !Array.isArray(accessToken)) {
        const decodedToken = this.tokenService.verifyAccessToken(accessToken);
        if (decodedToken && decodedToken.sub) {
          req.context.profileId = decodedToken.sub;
        }
      }
    }
    else {
      req.context.profileId = '0';
    }
    next();
  }
}
